import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// COMPONENTS
import BannerWatchNext from '@/components/Banners/BannerWatchNext';

function BannerWatchNextPromo({ analyticsLocation }) {
  const [t] = useTranslation();

  const title = t('watchNext.createBingeResults');
  const subtitle = t('watchNext.bannerSubText');
  const btnText = t('buttons.getStarted');

  return (
    <BannerWatchNext
      title={title}
      subtitle={subtitle}
      btnText={btnText}
      btnProps={{ location: analyticsLocation }}
    />
  );
}

BannerWatchNextPromo.propTypes = {
  analyticsLocation: PropTypes.string.isRequired,
};

export default React.memo(BannerWatchNextPromo);
